import { Table, Title, Stack, Skeleton, Badge, Group, Text } from '@mantine/core';
import { useWebhooks } from '@api/webhooks';

const EVENT_LABELS: Record<string, string> = {
  notify_sii_status: 'Notificación estado SII',
  notify_purchase_invoice: 'Notificación documento recibido',
};

function WebhookTable() {
  const { data, isFetching } = useWebhooks();

  const rows = data?.data.map((webhook) => (
    <Table.Tr key={webhook.id}>
      <Table.Td>
        {webhook.created_at ? new Date(webhook.created_at).toLocaleDateString('es-CL') : '-'}
      </Table.Td>
      <Table.Td>
        <Group gap={4} wrap="wrap">
          {webhook.events.length > 0 ? (
            webhook.events.map((event) => (
              <Badge key={event} variant="light" color="blue" size="sm">
                {EVENT_LABELS[event] ?? event}
              </Badge>
            ))
          ) : (
            <Text c="dimmed" fz="sm">
              Sin eventos
            </Text>
          )}
        </Group>
      </Table.Td>
      <Table.Td>
        <Text fz="sm" style={{ wordBreak: 'break-all' }}>
          {webhook.url}
        </Text>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <Stack maw={900} mx="auto" mt="md">
      <Title order={1}>Webhooks</Title>
      {isFetching ? (
        <Skeleton height={120} />
      ) : (
        <Table horizontalSpacing="md" verticalSpacing="md" highlightOnHover withTableBorder>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Fecha de creación</Table.Th>
              <Table.Th>Tipo de evento</Table.Th>
              <Table.Th>URL</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {(rows ?? []).length > 0 ? (
              rows
            ) : (
              <Table.Tr>
                <Table.Td colSpan={3}>No hay webhooks configurados</Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      )}
    </Stack>
  );
}

export default WebhookTable;
